import {combineReducers, createStore} from 'redux';
import appReducer from "../reducer/appReducer";

const createRootReducer = () => combineReducers({
    app: appReducer,
});

export const store = createStore(
    createRootReducer(),
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);
